export default {
    message: {
        hello: 'Hello',
        profile: 'Profile',
        search: 'Search for jobs and find top talent in Thailand…',
        language: 'Language'
    },
    header: {
        companyDetails: 'Company details',
        subscription: 'Subscription',
        jobShortlist: 'Job Shortlist',
        bookmarked: 'Bookmarked',
        settings: 'Settings',
        watchTutorial: 'Watch Tutorial',
        updateHiringPreferences: 'Update Hiring Preferences',
        blocked: 'Blocked',
        updatePassword: 'Update Password',
        logout: 'Logout',
        applications: 'Applications',
        updateJobPreferences: 'Update job preferences',
        blockedList: 'Blocked list'
    },
    index: {
        tagline: "Connecting you to Thailand",
        placeholder: "What are you looking for?",
        employmentNetwork: "Employment Network",
        betaTooltip: "This is a beta version for live signup & testing.",
        joinCommunity: "Join Our Community & Get Feature Updates First",
        article: "Article",
    },
    footer: {
        about: "About us",
        investors: "Investors",
        privacy: "Privacy Policy",
    },
    logout: {
        confirmTitle: 'Are you sure you want to logout?',
        confirm: 'Logout',
        cancel: 'Stay logged in'
    },
    homepage: {
        tagline: "Thailand’s Premier Employment Network",
        search: "Search for Jobs\n& Employees",
        global: "Locally rooted. Globally accessible.",
    },
    common: {
        no_results: "No results yet. Check back soon!",
        close: 'Close',
        save_changes: 'Save Changes',
        id: 'ID',
        block: 'Block',
        report: 'Report',
        verified: 'Verified',
        unblock: 'Unblock',
        getStarted: "Get Started",
        previous: "Previous",
        next: "Next",
        optional: "(Optional)",
        show: 'Show',
        hide: 'Hide',
        termsConfirmation: "I confirm that I have read and\nunderstand the Terms of Service",
        cancel: "Cancel",
        yes: "Yes!",
        and: "&",
        get_verified: "Get Verified",
    },
    auth: {
        employers: "Employers",
        employer_desc: "Post Jobs, Review Applications,\nFind Employees and Build\nwith Top Talent in Thailand.",
        employees: "Employees",
        employee_desc: "For Residents of Thailand.\nFind Local & International Job Opportunities For Free.",
        login: "Login",
        signup: "Sign up",
        no_account: "Don’t have an account?",
    },
    jobseeker: {
        featured_today: 'Featured Today:',
        spotlighted_talent: "Spotlighted Talent:",
        show_last: 'Show Last',
        show_next: 'Show Next',
        account_glance: 'Account at a glance:',
        bookmarked: 'Bookmarked',
        bookmarked_tooltip: 'Amount of employers following your account',
        profile_views: 'Profile views',
        profile_views_tooltip: 'Number of times your profile has been viewed',
        daily_contact: 'Daily submission allowance:',
        daily_contact_tooltip: 'Number of jobs you may apply to per day',
        account_completion: 'Account completion',
        sit_news: 'SearchinThailand News',
        posted: 'Posted',
        source: 'Source',
        job_picks_for_you: 'Job Picks For You:',
        preferred_listing_language: "Preferred Listing Language",
        thai: "Thai",
        english: "English",
        both: "Both",
        customized_connection: 'Discover Customized Connections:',
        position: 'Position',
        location: 'Location',
        subdistrict: 'Sub-District',
        posted_by: 'Posted by',
        salary: 'Salary',
        based_on_experience: 'Based on Experience',
        negotiable: 'Negotiable',
        to: 'to',
        Monthly: 'Monthly',
        Hourly: 'Hourly',
        Weekly: 'Weekly',
        Daily: 'Daily',
        quiz_description: 'Take a brief quiz to see personalized recommendations for ideal jobs or qualified candidates.',
        lets_go: 'Let’s go',
        quiz_confidential: 'Your responses are confidential and used only to enhance the quality of recommendations.',
        notifications: 'Notifications',
        notifications_tooltip: 'Unread notification messages',
        publish_account: 'Publish account',
        view_my_listing: 'View my listing',
        toggleVisibility: 'Toggle Visibility: Public or Private',
        no_news: 'No new messages',
        select_all: 'Select all',
        deselect_all: 'Deselect all',
        select_visible: 'Select visible',
        name: 'Name',
        website: 'Website',
        application_received: 'Application Received',
        apply_now: 'Apply for this job',
        remote_work: 'Remote Work',
        view_cv: 'View CV',
        download_cv: 'Download CV',
        applications: 'Applications',
        submission_date: 'Submission date',
        last_90_days: 'Last 90 days',
        no_applications: 'There are no applications.',
        blocked_accounts: 'Blocked Accounts',
        no_blocked_accounts: 'There are no blocked accounts.',
        pause_job: 'Pause Job',
        edit_job: 'Edit Job',
        delete_job: 'Delete Job',
        applications_num: 'Applications',
        new: 'New',
        job_listing: 'Job Listing',
        active: 'Active',
        expired: 'Expired',
        expires: 'Expires',
        no_published_jobs: 'No published job notifications',
        language: "Language",
        availability: "Availability",
        apply_by: "Apply by",
    },
    loginJobSeeker: {
        title: 'Login',
        email: 'Email',
        password: 'Password',
        email_placeholder: 'Enter your email',
        password_placeholder: 'Enter your password',
        login_button: 'Login',
        no_account: "Don't have an account?",
        signup_here: 'Sign up here',
        forget_password: 'Forgot password?',
        click_here: 'Click here',
        remember_account: 'Remember account',
        login_as: 'Login as',
        other_account: 'Login with other account'
    },
    loginEmployer: {
        title: 'Employer Login',
        email: 'Email',
        password: 'Password',
        email_placeholder: 'Enter your email',
        password_placeholder: 'Enter your password',
        login_button: 'Login',
        no_account: "Don't have an account?",
        signup_here: 'Sign up here',
        forget_password: 'Forgot password?',
        click_here: 'Click here',
        remember_account: 'Remember account',
        login_as: 'Login as',
        other_account: 'Login with other account'
    },
    jobSeekerProfile: {
        hi: 'Hi',
        verified: 'Verified',
        founding_supporter: 'Founding Supporter',
        addSocial: 'Add Social Media',
        memberId: 'Member ID',
        since: 'Since',
        profilePreferences: 'Profile Preferences',
        searchJobs: 'Search Jobs',
        notifications: 'Notifications',
        accountPreferences: {
            email: 'Email Address:',
            first_name: 'First Name:',
            last_name: 'Last Name:',
            about_me: 'About me:',
            about_me_placeholder: 'Enter your information.',
            upload_cv: 'Upload CV:',
            browse_file: 'Browse file',
            allowed_formats: 'Only .pdf, .doc, .docx, Jpg, Jpeg, Webp, and PNG formats are allowed',
            download_cv: 'Download CV',
            education: 'Education Level:',
            select_education: 'Select Education level',
            gender: 'Gender:',
            select_gender: 'Select Gender',
            birthdate: 'Birthdate:',
            enter_birthdate: 'Enter Birthdate',
            languages: 'Languages Spoken:',
            select_languages: 'Add up to 3',
            contact_by: 'Allow employers to contact you by:',
            phone: 'Phone',
            line_id: 'Line ID',
            search_job_position: "Search Job Title or Position",
            search_job_position_placeholder: "Start typing to search for job position",
            industry_of_interest: "Primary Industry:",
            select_industry: "Select Industry",
            area_of_expertise: 'Area of Expertise:',
            select_specialization: 'Select Specialization',
            select_industry_first: 'Select Industry First',
            preferred_job_roles: 'Select Job Roles (You Can Choose Multiple):',
            position_types: 'Position Types',
            selectIndustryFirst: "Select Industry First",
            preferredRoles: "Preferred Job Roles",
            province: "Province:",
            select_province: "Select Province:",
            district: "District:",
            select_district: "Select District:",
            sub_district: "Sub-District:",
            select_sub_district: "Select Sub-District:",
            zip_code: "Zip Code:",
            desired_employment_type: "Employment Type:",
            employment_type: "Desired Employment Type:",
            selectEmploymentType: "Employment Type:",
            availability: "Availability for Work",
            availability_for_work: "Availability:",
            select_availability: "Choose Days Available:",
            days_available: 'Choose Days Available:',
            select_days_available: "Select days available:",
            desired_compensation: "Compensation:",
            compensation: "Compensation",
            compensationMobile: "Compensation:",
            salary: 'Compensation:',
            amount: 'Amount:',
            to: "to",
            currency: "฿",
            update: 'Update',
        },
        job_category: "Job Category",
        location: "Location",
        subdistrict: "Sub-District",
        zipcode: "Zipcode",
        languages: "Languages",
        availability: "Availability",
        apply_by: "Apply by",
        salary_requirements: "Salary Requirements",
        member_id: "Member ID",
        joined: "Joined",
        about_me: "About Me",
        position_details: 'Position details',
        edit_profile: 'Edit Profile',
        last_login: 'Last Login',
    },
    jobSeekerSearch: {
        work_location: "Work Location",
        province: "Province",
        any: "Any",
        local: "Local",
        remote: "Remote",
        placeholder: "Search for local and remote jobs...",
        job_filter_options: "Job Filter Options",
        industry: "Industry",
        select_industry: "Select Industry",
        specialization: "Specialization",
        optional: "(Optional)",
        position: "Position",
        position_types: "Position Types",
        select_specialization_first: "Select Specialization First",
        salary_range: "Salary Range",
        to: "to",
        language: "Language",
        availability: "Availability",
        simple_search: "Simple Search",
        clear_fields: "Clear Fields",
        search: "Search",
        posted_by: "Posted by",
        location: "Location",
        remote_work: "Remote Work",
        apply_by: "Apply by",
        salary: "Salary",
        based_on_experience: "Based on Experience",
        negotiable: "Negotiable",
        position_details: "Position details",
        no_results: "No results yet. Check back soon!",
    },
    jobSeekerMessages: {
        block_user: "Block User",
        delete_notification: "Delete Notification",
        company: "Company",
        view_detail: "View Detail",
        time: "Time",
        contacted_by: "Contacted by",
        date: "Date",
        view_details: "View details",
        no_new_notifications: "No new notification messages",
        contacted: 'Attempted to contact you!',
    },
    jobseekerQuiz: {
        title: 'Unlock Your Job Potential',
        description: 'Complete a short quiz to discover job opportunities that match your skills and qualifications.',
        lets_go: 'Let’s go',
        confidentiality: 'Your responses are confidential and used only to enhance the quality of your recommendations.',
        retake_quiz: 'Retake Quiz',
        submit_answers: 'Submit Answers',
        next_question: 'Next',
        previous_question: 'Back',
        finish: 'Finish',
        loading: 'Loading quiz...',
        no_questions: 'No quiz questions available.',
        title_job: 'Career Preferences',
        question_progress: 'Question {current} of {total}',
        thank_you: 'Thank you for your responses.',
        completed: 'You have completed the quiz.',
        back: 'Back',
        next: 'Next',
    },
    quiz: {
        complete: "Complete the Quiz",
        receive: "and Receive Personalized Job Recommendations."
    },
    employer: {
        contact_name: 'Contact Name',
        company_website: 'Company Website',
        location: 'Location',
        subdistrict: 'Sub-District',
        phone_registration: 'Phone Registration',
        about: 'About',
        joined_on: 'Since:',
        job_dashboard: 'Job Dashboard',
        employee_search: 'Employee Search',
        applications: 'Applications',
        new: 'New',
        create_new_job: 'Create new job',
        publish: 'Publish',
        private: 'Private',
        position_type: 'Position Type',
        preferred_listing_language: 'Preferred Listing Language',
        job_type: 'Job Type',
        language: 'Language',
        remote_work: 'Remote Work',
        compensation: 'Compensation',
        based_on_experience: 'Based on Experience',
        negotiable: 'Negotiable',
        expires: 'Listing Expires',
        block_user: 'Block User',
        delete_application: 'Delete Application',
        user_name: 'User Name',
        added_to_shortlist: 'Added to Job Shortlist',
        add_to_shortlist: 'Add applicant to Job Shortlist',
        submitted_application: 'Submit an application',
        application_time: 'Application Time',
        job_title: 'Job Title',
        application_date: 'Application Date',
        no_new_applications: 'No new applications',
        verified: "Verified",
    },
    employerProfile: {
        spotlighted_talent: "Spotlighted Talent:",
        job_dashboard: "Job Dashboard",
        employee_search: "Employee Search",
        applications: "Applications",
        new_applications: "New Applications",
        founding_supporter: 'Founding Supporter',
        job_title: "Job Title",
        applicant_name: "Applicant Name",
        application_date: "Application Date",
        application_time: "Application Time",
        add_to_shortlist: "Add applicant to Job Shortlist",
        added_to_shortlist: "Added to Job Shortlist",
        block_user: "Block User",
        delete_application: "Delete application",
        no_applications: "No new applications",
        email: "Email",
        first_name: "First Name",
        last_name: "Last Name",
        company_name: "Company Name",
        company_industry: "Company Industry",
        company_address: "Company Address",
        company_website: "Company Website",
        country: "Country",
        province: "Province / State",
        district: "District / City",
        sub_district: "Sub-District",
        zipcode: "Zip Code",
        phone_registration: 'Phone Registration',
        introduction: "Company Introduction",
        introduction_count: "Characters Used",
        save_changes: "Save Changes",
        select_industry: "Select Company Industry",
        select_country: "Select Country",
        please_select_country: "Please select country",
        profile_since: "Since",
        last_login: "Last Login",
        member_id: "Member ID",
        edit_profile: "Edit Profile",
        subscription_plan: "Subscription Plan",
        current_plan: "You're on the plan:",
        plan_expires: "Plan Expires:",
        verified_account: "Verified Account",
        daily_applications: "Daily Applications",
        smart_notifications: "Smart Notifications",
        early_access: "Early Access",
        supporter_badge: "Founding Supporter Badge",
        free_plan: "You're on the Free Plan.",
        upgrade_cta: "Upgrade for more reach, faster access, and exclusive features.",
        upgrade_now: "See Upgrade Options",
        featured_today: 'Featured Today:',
        show_last: 'Show Last',
        show_next: 'Show Next',
        account_glance: 'Account at a glance:',
        active_projects: 'Active Projects',
        bookmarked: 'Bookmarked',
        account_views: 'Account views',
        daily_contact: 'Daily contact allowance:',
        view_company_listing: 'View company listing',
        news_header: 'SearchinThailand News',
        news_posted: 'Posted',
        news_source: 'Source',
        news_empty: 'No new messages',
        start_matching_title: 'Let’s Get Started with Your Matches',
        start_matching_description: 'Complete this quiz to unlock tailored candidate recommendations.',
        lets_go: 'Let’s go',
        quiz_confidential: 'Your responses are confidential and used only to enhance the quality of recommendations.',
        recommended_candidates: 'Recommended Candidates:',
        no_recommendations: 'No candidate recommendations yet',
        name: 'Name',
        location: 'Location',
        subdistrict: 'Sub-District',
        specialization: 'Specialization',
        skills: 'Skills',
        job_shortlist: 'Job Shortlist',
        no_favorites: 'No favorites yet.',
        remove: 'Remove',
        job_category: 'Job Category',
        availability: 'Availability',
        compensation: 'Compensation',
        negotiable: 'Negotiable',
        close: 'Close',
        bookmark_empty: 'Your bookmark list is currently empty.',
        blocked: 'Blocked',
        unblock: 'Unblock',
        no_blocked_accounts: 'There are no blocked accounts.',
        update_password: 'Update Password',
        current_password: 'Current Password',
        new_password: 'New Password',
        confirm_new_password: 'Confirm New Password',
        password_matched: 'Password matched',
        incorrect_password: 'Incorrect current password',
        password_different: 'New password is different from old password',
        password_same: 'New password must not be same as old password',
        passwords_match: 'Passwords match',
        passwords_not_match: 'New password and confirmation do not match',
        send_message: "Send Message",
        no_messages: "No messages yet.",
        from: "From",
        to: "To",
        enter_message: "Enter your message",
        languages: "Languages",
        salary_requirements: "Salary Requirements",
        since: "Since",
        block: "Block",
        report: "Report",
        bookmark: "Bookmark",
        verified: "Verified",
        about: "About",
        view_contact: "View Contact",
        view_cv: "View my CV",
        call: "Call",
        contact_name: "Contact Name",
        edit_intro: "Edit Introduction",
        enter_company_info: "Enter company information.",
        joined: "Joined",
        socialMedia: {
            update: "Update - Social Media",
            name: "Social Media Name",
            url: "Social Media URL",
            goToLink: "Go to link",
            save: "Save",
            remove: "Remove"
        },
        banner: {
            title: 'Banner',
            upload: 'Upload File'
        },
    },
    employerQuiz: {
        title: "Employer Preferences",
        question: "Question",
        of: "of",
        complete: "Quiz complete!",
        saved: "Your responses have been recorded.",
        back: "Back",
        next: "Next",
        close: "Close"
    },
    employerPostJob: {
        create_new_job: "Create new job",
        updatePost: "Update post",
        jobTitle: "Job Title",
        jobDescription: "Job Description",
        searchJobPosition: "Search Job Position",
        jobCategory: "Job Category",
        positionType: "Position Type",
        selectPosition: "Select Position",
        compensation: "Compensation",
        fixedAmount: "Fixed Amount",
        paymentRange: "Payment Amount (Range)",
        experience: "Based on Experience",
        negotiable: "Negotiable",
        languagesSpoken: "Languages Spoken",
        employmentType: "Employment type",
        specifyLocation: "Specify Location",
        remoteWork: "Remote Work",
        flexible: "Flexible",
        province: "Province",
        district: "District",
        subDistrict: "SubDistrict",
        zipCode: "Zip Code",
        jobExpiration: "Job listing expiration date",
        preview: "Continue to Preview",
        update: "Update",
        cancel: "Cancel Job",
        visibilityNote: "How long should your job post be visible? (Limit: 30 days)",
        job_title: "Job Title",
        job_title_placeholder: "Enter the job title for this listing.",
        job_description: "Job Description",
        job_description_placeholder: "Describe the responsibilities, qualifications, and any other relevant details about the role…",
        search_position: "Search Job Position",
        search_position_placeholder: "Start typing to search for job position",
        job_category: "Job Category",
        job_category_placeholder: "Search job categories",
        position_type: "Position Type",
        position_type_placeholder: "Select position type",
        select_position: "Select Position",
        select_position_placeholder: "Select the position you're seeking",
        validate_title: 'Please enter job title',
        validate_category: 'Please select job category',
        validate_position_types: 'Please select position types',
        validate_sub_position_types: 'Please select sub position types',
        validate_province: 'Please select province',
        validate_amphure: 'Please select amphure',
        validate_district: 'Please select district',
        validate_zip: 'Please enter zip code',
        validate_expire_date: 'Please set expire date',
        validate_expire_time: 'Please set expire time',
        validate_payment_amount: 'Please enter payment amount',
        validate_payment_range: 'Please enter payment amount',
        validate_payment_type: 'Please enter payment type',
        validate_language: 'Please enter languages spoken',
        validate_availability: 'Please select availability',
    },
    employerPost: {
        compensation: {
            title: "Compensation",
            fixed: "Fixed Amount",
            range: "Payment Amount (Range)",
            experience: "Based on Experience",
            negotiable: "Negotiable",
            enterFixed: "Enter Fixed Amount",
            min: "Min",
            max: "Max",
            to: "to",
            per: "per",
            hour: "Hour",
            day: "Day",
            week: "Week",
            month: "Month",
            job: "Job",
        },
        language: {
            label: "Languages Spoken",
            placeholder: "Enter the required languages (e.g., English, Thai, Chinese)."
        },
        employmentType: {
            label: "Employment type",
            placeholder: "Select the type of employment for this position"
        },
        showAddress: {
            label: "Show Address"
        },
        location: {
            specify: "Specify Location",
            remote: "Remote Work",
            flexible: "Flexible",
            info: "Allows both location and remote work",
            province: "Province",
            district: "District",
            subDistrict: "Sub-District",
            zip: "Zip Code",
            selectProvince: "Select Province",
            selectDistrict: "Select District",
            selectSubDistrict: "Select Sub-District",
        },
        expiration: {
            label: "Job listing expiration date",
            placeholder: "dd/mm/yyyy hh:mm",
            note: "How long should your job post be visible? (Limit: 30 days)"
        },
        footer: {
            preview: "Continue to Preview",
            update: "Update",
            cancel: "Cancel Job"
        }
    },
    account: {
        update_password: 'Update Password',
        current_password: 'Current Password',
        new_password: 'New Password',
        confirm_new_password: 'Confirm New Password',
        password_matched: 'Password matched',
        incorrect_current_password: 'Incorrect current password',
        password_is_different: 'New password is different from old password',
        password_same_as_old: 'New password must not be same as old password',
        passwords_match: 'Passwords match',
        passwords_do_not_match: 'New password and confirmation do not match',
        upgrade_account: 'Upgrade Account',
        secure_payment_note: '🔒 Secure one-time payment. No auto-renewals.',
        no_subscription_required: 'No Subscription Required!',
        subscription_plan: 'Subscription Plan',
        current_plan: 'You’re on the plan:',
        plan_expires: 'Plan Expires:',
        verified_account: 'Verified Account',
        verified_description: 'You’re now verified and more visible to employers.',
        daily_applications: 'Daily Applications',
        jobs_per_day: 'jobs per day.',
        smart_notifications: 'Smart Notifications',
        smart_notifications_desc: 'Get alerted when jobs match your skills.',
        early_access: 'Early Access',
        early_access_desc: 'You’ll be notified when Freelancer Mode, Profile Boosts, and other features launch.',
        founding_supporter: 'Founding Supporter Badge',
        founding_supporter_desc: 'Thanks for being an early supporter!',
        on_free_plan: "You're on the Free Plan.",
        apply_limit: 'Apply to',
        upgrade_benefits: 'Upgrade for more reach, faster access, and exclusive features.',
        see_upgrade_options: 'See Upgrade Options',
        password_rules: [
            'Must be at least 12 characters',
            'Can include letters, numbers, symbols, and spaces'
        ],
        password_min_length: 'Password must be at least 12 characters.',
        new_password_required: 'New password cannot be empty.',
        password_updated: 'Password updated successfully.',
        password_update_error: 'An error occurred. Please try again.',
    },
    socialMedia: {
        title: 'Update - Social Media',
        name: 'Social Media Name',
        url: 'Social Media URL',
        visit_link: 'Go to link',
        addTitle: 'Add Social Media',
        selectPlaceholder: 'Select Social Media',
        urlPlaceholder: 'Social Media URL',
        validationRequired: 'Both fields are required!',
        validationInvalid: 'Invalid URL for the selected social media!',
        successTitle: 'Success!',
        successMessage: 'Social media added successfully.',
    },
    general: {
        no_results_check_accounts: 'No results yet. Check out these accounts instead.'
    },
    upgradeEmployer: {
        title: "Exclusive 1st Year Discount",
        heading: "Upgrade Your Hiring Strategy",
        description: "Enjoy special discounted prices during our first year – get more value while streamlining your recruitment process in Thailand.",
        basicPlan: "Basic Plans",
        enterprisePlan: "Enterprise Plans",
        popular: "MOST POPULAR",
        discountedFrom: "Discounted from",
        noSubscription: "No Subscription Required!",
        close: "Close"
    },
    subscriptionEmployer: {
        title: "Subscription:",
        yourId: "Your ID:",
        memberSince: "Member since:",
        plan: "Subscription Plan:",
        expiration: "Expiration Date:",
        upgrade: "Upgrade Your Plan",
        close: "Close"
    },
    jobDetail: {
        category: 'Job Category',
        location: 'Location',
        remote: 'Remote Work',
        availability: 'Availability',
        language: 'Language',
        compensation: 'Compensation',
        experienceBased: 'Based on Experience',
        negotiable: 'Negotiable',
        positionDetails: 'Position details:',
        postedBy: 'Posted by:',
        name: 'Name',
        website: 'Website',
        viewDetail: 'View Detail',
        viewCompany: 'View Company',
    },
    postJob: {
        publish: 'Publish Job Listing',
        update: 'Update job',
        backToEdit: 'Back to Edit'
    },
    employerSignup: {
        locationVerification: "Location Verification",
        alreadyHaveAccount: "Already have an account?",
        login: "Log in",
        createPassword: "Create Password",
        createPasswordNote: "Please create a password for your account",
        companyInfo: "Company Information",
        tellUsCompany: "Tell us about your company",
        phoneVerification: "Phone Number Verification",
        phoneVerificationNote: "Please verify your phone number",
        choosePlan: "Choose the Best Plan for your Business",
        discoverTalent: "Discover top talent in Thailand",
        streamlineTools: "with tools to streamline your hiring.",
        companyAddress: "Company Address",
        verifyIdentity: "Verify your Identity",
        completeRegistration: "complete your registration and",
        secureExperience: "ensure a secure experience",
        notLocated: "You are not located in Thailand.",
        connectTitle: "Connect with Top Talent in Thailand",
        connectDesc: "Join our network to access skilled professionals across industries in Thailand, tailored to meet your hiring needs",
        connectTalentTitle: "Connect with Talent",
        connectTalentDesc: "Search and reach out to professionals who match your needs.",
        postJobsTitle: "Post Jobs Easily",
        postJobsDesc: "Create job listings quickly and attract the right candidates.",
        personalizedTitle: "Personalized Matches",
        personalizedDesc: "Save time by focusing on potential hires who align with your specific requirements, powered by our recommendation engine.",
        streamlineTitle: "Streamline Hiring",
        streamlineDesc: "Manage and rank potential hires. Bookmark candidates, assign job-specific shortlists, and streamline your hiring process.",
        firstName: "First Name",
        firstNamePlaceholder: "First name",
        lastName: "Last Name",
        lastNamePlaceholder: "Last name",
        companyName: "Company Name",
        companyNamePlaceholder: "Enter Company Name",
        companyNameExists: "Company name already in use…",
        email: "Email",
        emailPlaceholder: "Enter Your Email",
        confirmEmail: "Confirm Email",
        agree: "I agree to the",
        termsOfService: "Terms of Service",
        sendVerification: "Send Email Verification Code",
        verificationCode: "Enter Verification Code",
        codePlaceholder: "Verification Code",
        password: "Password",
        passwordPlaceholder: "Enter Password",
        confirmPassword: "Confirm Password",
        confirmPasswordPlaceholder: "Confirm Password",
        industry: "Company Industry",
        selectIndustry: "Select Company Industry",
        size: "Company Size",
        selectSize: "Select Company Size",
        website: "Company Website",
        websitePlaceholder: "Enter Website (Optional)",
        address: "Company Address",
        addressPlaceholder: "Enter Company Address",
        country: "Country",
        selectCountry: "Select Country",
        city: "District / City",
        selectDistrict: "Select District",
        province: "Province / State",
        selectProvince: "Select Province",
        zip: "Zip Code",
        selectCountryFirst: "Please select country first",
        phoneLabel: "Phone number",
        sendVerificationPhone: "Send Verification Code",
        enterVerificationCode: "Enter Verification Code",
        verificationCodePlaceholder: "Verification Code",
        create: "Create",
        popular: "MOST POPULAR",
        noSubscription: "No subscription Required!",
        purchaseOption: "Option to purchase additional job listing",
        subscribe: "Subscribe",
    },
    employerSignupOnly: {
        pricePrefix: "Only",
        priceSuffix: "/ year",
        noSubscription: "No Subscription Required !",
        unlock: "Unlock Premium Features",
        features1: [
            "Be Searchable: Your information will appear in employee search results",
            "Update Location: Keep your location current to attract nearby employers",
            "Profile Insights: Track how many people have viewed your profile",
            "Notifications: Get alerts when someone attempts to contact you and see their location"
        ],
        profileManagement: "Profile Management",
        features2: [
            "Add a profile image",
            "Upload your CV",
            "View Employer details",
            "Write a personal introduction",
            "Control profile visibility"
        ],
        andMore: "And More!",
        payBy: "Pay by",
        qrCode: "QR Code",
        card: "Credit or Debit"
    },
    terms: {
        title: 'Terms of Service (Employer)',
        intro: 'Welcome to Search in Thailand Jobs Board. By registering an account and using our services as an employer, you agree to comply with the following terms:',
        footer: 'By creating an employer account, you agree to these terms and confirm that you have read, understood, and accepted this legal disclaimer.',
        sections: [
            {
                heading: '1. Legal Eligibility',
                text: 'You affirm that you are legally permitted to hire employees in Thailand according to the current laws and regulations as of 2024...'
            },
            {
                heading: '2. Verification of Legal Status',
                text: 'It is your sole responsibility to ensure that you possess the appropriate legal authorization to hire employees in Thailand...'
            },
            {
                heading: '3. Absolution of Responsibility',
                text: 'SearchinThailand.com and Talent Partners Co., Ltd. are not responsible for verifying the legal eligibility...'
            },
            {
                heading: '4. Compliance with Thai Law',
                text: 'You agree to comply with all applicable laws and regulations of Thailand while using our platform...'
            },
            {
                heading: '5. Prohibited Activities',
                list: [
                    'Using the names, photos, or personal information of others without their consent.',
                    'Engaging in Lèse-majesté or violating Section 112 of the Thai Criminal Code.',
                    'Engaging in fraudulent activities or impersonation.',
                    'Discriminating based on race, gender, religion, etc.',
                    'Infringing intellectual property rights.',
                    'Harassment, abuse, or bullying.',
                    'Collecting personal data without consent.',
                    'Promoting pyramid schemes or deceptive practices.',
                    'Misusing contact information.',
                    'Posting fake job listings.',
                    'Spreading malware.',
                    'Data scraping without permission.',
                    'Manipulating user ratings.'
                ]
            },
            {
                heading: '6. Communication and Conduct',
                list: [
                    'Only contact job seekers for employment purposes.',
                    'Avoid any form of harassment.',
                    'Ratings must be fair and honest.'
                ]
            },
            {
                heading: '7. Reporting and Accountability',
                text: 'Both employers and job seekers can report misconduct. Our team will review and respond appropriately.'
            },
            {
                heading: '8. Account Termination',
                text: 'Violation of terms can result in immediate account termination and permanent ban.'
            },
            {
                heading: '9. Data Protection',
                text: 'We prioritize protecting your data, but you are responsible for your credentials.'
            },
            {
                heading: '10. Limitation of Liability',
                text: 'We are not liable for damages resulting from your use of the platform.'
            },
            {
                heading: '11. Changes to Terms',
                text: 'We may update these terms. Continued use means acceptance of the latest version.'
            }
        ]
    },
    jobseekerProfileModal: {
        tooltipNotInterestedLogin: "Please login to Not interested",
        tooltipBookmarkLogin: "Please login to Bookmark",
        notInterested: "Not interested",
        removeNotInterested: "Remove from not interested list",
        bookmark: "Bookmark",
        removeBookmark: "Remove from list",
        jobCategory: "Job Category:",
        availability: "Availability:",
        salary: "Salary Requirements:",
        negotiable: "Negotiable",
        languages: "Languages Spoken:",
        aboutMe: "About me:",
        call: "Call",
        sendMessage: "Send Message",
        lineId: "Line ID",
        viewCV: "View my CV",
        memberSince: "Member Since"
    },
    jobSeekerSignup: {
        locationVerification: {
            title: "Location Verification",
            notInThailand: "You are not located in Thailand.",
            back: "Back",
        },
        step0: {
            heading: "Sign Up Free and Jumpstart Your Career",
            subheading: "Connect with Employers in Thailand and Beyond",
            findJobsTitle: "Find Jobs Fast",
            findJobsDesc: "Discover job listings that match your skills and goals, and apply directly from your profile.",
            showcaseTitle: "Showcase Your Talent",
            showcaseDesc: "Build a searchable profile where employers can see your experience, skills, and resume.",
            instantConnectTitle: "Instant Connections",
            instantConnectDesc: "Engage with employers across Thailand and worldwide, and let opportunities come to you.",
            personalizedTitle: "Personalized Matches",
            personalizedDesc: "Unlock job recommendations that align with your strengths and preferences.",
            getStarted: "Get Started"
        },
        step1: {
            heading: "Sign Up Free and Jumpstart Your Career",
            subheading: "Connect with Employers in Thailand and Internationally",
            alreadyHaveAccount: "Already have an account?",
            login: "Log in",
            firstName: "First Name",
            lastName: "Last Name",
            firstNamePlaceholder: "Enter your first name",
            lastNamePlaceholder: "Enter your last name",
            email: "Email",
            emailPlaceholder: "Enter your Email",
            confirmEmail: "Confirm Email",
            confirmEmailPlaceholder: "Re-enter your Email",
            termsOfService: "I agree to the",
            termsLink: "Terms of Service",
            legalAge: "I certify I am at least 18 years of age and legally capable of working in Thailand.",
            sendCode: "Send Email Verification Code",
            enterCode: "Enter Email Verification Code",
            codePlaceholder: "Verification Code"
        },
        step2: {
            heading: "Create Password",
            description: "Please create a password for your account.",
            password: "Password",
            passwordPlaceholder: "Enter Password",
            confirmPassword: "Confirm Password",
            confirmPasswordPlaceholder: "Confirm Password"
        },
        step3: {
            preferencesTitle: "Employment Preferences",
            searchJobPosition: "Search Job Position",
            searchJobPositionPlaceholder: "Start typing to search for job position",
            desiredIndustry: "Desired Industry",
            desiredIndustryPlaceholder: "Search job categories",
            specialization: "Specialization",
            specializationPlaceholder: "Select position type",
            position: "Position",
            positionPlaceholder: "Position Types",
            employmentType: "Employment Type",
            selectEmploymentType: "Specify type of work you're seeking",
            availability: "Availability",
            daysAvailable: "Days Available",
            selectDaysAvailable: "Choose Days Available",
            selectCustomDays: "Select days available",
            payments: "Payments",
            salaryExpectations: "Salary Expectations",
            selectPaymentType: "Select desired payment type",
            enterRange: "Enter Range"
        },
        step4: {
            title: "Phone Number Verification",
            subtitle: "Thanks {name}, please use a local Thai number only.",
            sendCodeButton: "Send Verification Code",
            enterCodeLabel: "Enter Verification Code",
            phonePlaceholder: "Enter your phone number"
        },
        step5: {
            title: 'Preferred Contact Method',
            subtitle: 'How would you like to be contacted by potential employers?',
            selectInstruction: 'Select your preferred option(s) below:',
            emailLabel: 'Email',
            emailNote: 'Employers may contact you through internal messaging only. Your email address is never shared.',
            phoneLabel: 'Phone',
            phoneNote: 'Your phone number will be visible only to verified employers.',
        },
        step6: {
            title: 'Complete Your Registration',
            subtitle1: 'Apply to 3 jobs per day for free.',
            subtitle2: 'Subscribe for free and unlock the full potential of our platform.',
            signupNow: 'Sign up Now',
            unlockFeatures: 'Unlock Premium Features',
            feature1: { title: 'Be Searchable:', desc: 'Your information will appear in employee search results' },
            feature2: { title: 'Update Location:', desc: 'Keep your location current to attract nearby employers' },
            feature3: { title: 'Profile Insights:', desc: 'Track how many people have viewed your profile' },
            feature4: { title: 'Notifications:', desc: 'Get alerts when someone attempts to contact you and see their location' },
            profileManagement: 'Profile Management',
            pm1: 'Add a profile image',
            pm2: 'Upload your CV',
            pm3: 'View Employer details',
            pm4: 'Write a personal introduction',
            pm5: 'Control profile visibility',
            andMore: 'And More!',
            signUp: 'Sign Up',
            forFree: 'for Free'
        },
        previous: "← Previous",
        next: "Next →",
        createAccount: 'Create Account',
    },
    jobSearch: {
        placeholder: 'Search for jobs and find top talent in Thailand…',
        filterOptions: 'Filter options',
        loginWarning: 'Please create an account or login to search for jobs or employees.',
        enterSearchTerm: 'Please enter a search term',
        selectIndustryFirst: "You must select ‘Industry’ before you can search",
        search: "Search",
        industry: "Industry",
        selectIndustry: "Select Industry",
        specialization: "Specialization",
        selectSpecialization: "Specialization",
        optional: "(Optional)",
        position: "Position",
        positionTypes: "Position Types",
        province: "Province",
        language: "Language",
        simpleSearch: "Simple Search",
        advancedSearch: "Advanced Search",
        clearFields: "Clear Fields",
        district: "District",
        selectDistrict: "Select District (optional)",
        subdistrict: "Subdistrict",
        selectSubdistrict: "Select Subdistrict",
        salaryRequirement: "Salary Requirement",
        salaryRequirementPlaceholder: "Salary Requirements",
        gender: "Gender",
        selectGender: "Select Gender",
        availability: "Availability",
        industryRequired: "You must select ‘Industry’ before can search",
    },
    aboutUs: {
        heart: 'At the heart of our work:',
        mission: 'A simple but powerful mission — to connect people, businesses, and communities across Thailand by building accessible, intelligent digital infrastructure that strengthens local opportunities and expands international reach.',
        believe: 'We believe:',
        vision: 'Opportunity should be easy to find and act upon — whether you’re a job seeker searching for the right position, a business looking for the right talent, or an entrepreneur ready to grow. By organizing Thailand’s resources and improving access to both local and global opportunities, we are helping build a stronger, more connected economy for the future.',
        cta: "Let's go!"
    },
    investors: {
        title: "Invest in Thailand’s Future",
        desc1: "SearchinThailand is building the country’s first dedicated search and employment ecosystem — connecting people, businesses, and opportunities locally and internationally.",
        desc2: "As we prepare for launch, we are open to strategic partnerships and investment opportunities that align with our mission to strengthen Thailand’s economy and digital infrastructure.",
        desc3: "If you are interested in learning more, please send us a message. We would be happy to discuss how you can be part of this journey.",
        form: {
            name: "Your Name",
            email: "Your Email",
            message: "Your Message",
            send: "Send Message"
        }
    },
    privacy: {
        title: "Privacy Policy",
        introTitle: "Introduction",
        introText: "Welcome to SearchinThailand.com. We are committed to respecting your privacy and safeguarding your personal information with a 'Privacy First' approach. Our policies follow the principles of Thailand's Personal Data Protection Act (PDPA).",

        glanceTitle: "At a Glance",
        glance: {
            collection: "Collection: Basic personal details, search queries, location, device info, and usage statistics.",
            method: "Method: Information gathered via direct inputs and cookies.",
            use: "Use: Improving services, personalization, and security.",
            sharing: "Sharing: Only if legally mandated. We do not sell your data.",
            protection: "Protection: Encryption, access controls, audits.",
            rights: "Rights: Manage your data directly via your account."
        },

        infoCollectTitle: "Information We Collect",
        infoCollectText: "We collect anonymized search queries, personal information for account management, device details for optimization, and usage data to enhance the user experience.",

        useInfoTitle: "Use of Your Information",
        useInfoText: "We use your data to personalize and improve your experience, develop new features, and maintain security.",

        shareProtectTitle: "Sharing and Protection of Information",
        shareProtectText: "We do not sell your data. We share it only under legal requirements and protect it through encryption, anonymization, access controls, and regular security audits.",

        rightsTitle: "Your Rights",
        rights: {
            access: "Access and Portability:",
            accessText: "Download your data in a readable format.",
            rectify: "Rectification:",
            rectifyText: "Correct inaccurate information through your account.",
            erase: "Erasure:",
            eraseText: "Delete your account and associated data.",
            restrict: "Restriction and Objection:",
            restrictText: "Limit how we process your data.",
            automated: "Automated Decision-Making:",
            automatedText: "No major decisions are made solely by automated processes.",
        },

        retentionTitle: "Data Retention",
        retentionText: "Account data is kept as long as your account is active. Anonymized search and usage data may be retained indefinitely for improvement purposes. Customer support data is kept only as long as necessary.",

        transferTitle: "International Data Transfers",
        transferText: "Your data may be stored on dedicated U.S.-based servers with protections aligned to PDPA standards through strict contractual clauses.",

        breachTitle: "Data Breach Notification",
        breachText: "In case of a breach, we will promptly assess, contain, notify affected users, and document the incident for accountability and future improvements.",

        legalTitle: "Legal Bases for Processing",
        legalIntro: "We process your data based on:",
        legal: {
            consent: "Consent for optional services like marketing communications.",
            contract: "Contract performance for service delivery.",
            obligation: "Legal obligations for compliance.",
            interests: "Legitimate interests such as operational improvements and fraud prevention."
        },

        updateTitle: "Updates to This Policy",
        updateText: "We will inform you of any significant changes to this Privacy Policy via the website, email, or account notifications.",

        contactTitle: "Contact Us",
        contactText: "If you have any questions or wish to exercise your privacy rights, please contact us at:"
    },
    modalLanguageLevel: {
        cancel: 'Cancel',
    },
    toast: {
        login_required_employer: `Please login to 'Employer Account' to use this feature <br>(You can click here to login.)`,
        login_required_employee: `Please login to 'Employee Account' to use this feature <br>(You can click here to login.)`,
        language_limit: 'You can only select up to 3 languages',
    },
    support: {
        title: "Help & Support",
        reportIssue: "Feedback & Support",
        systemNotifications: "System Notifications",
        securityAlerts: "Security & Alerts",
        knowledgeBase: "Knowledge Base / FAQ",
    },
    notifications: {
        system: 'System Notifications',
        security: 'Security & Alerts',
        default: 'Notifications',
        none: 'No notifications.',
        close: 'Close',
    },
    chat: {
        noMessages: "No messages yet",
        deleteMessage: "Delete Message",
        noChats: "No chats found. Try refreshing or start a new conversation.",
        deleteConversation: "Delete Conversation",
        blockUser: "Block User",
        bookmarkUser: "Bookmark User",
        edited: "Edited",
        edit: "Edit",
        delete: "Delete",
        editPlaceholder: "Edit your message...",
        messagePlaceholder: "Type a message...",
        cancel: "Cancel",
        deleteNotifTitle: "Delete notification?",
        deleteNotifText: "", // or "Are you sure you want to delete this notification?"
        deleteConversationTitle: "Delete this conversation?",
        deleteConversationText: "", // or "This action cannot be undone.",
        confirmDelete: "Delete",
        deleteMessageTitle: "Delete this message?",
        deleteMessageText: "", // or "This action cannot be undone."
        blockUserTitle: "Block this user?",
        blockUserText: "", // or "You won't receive messages from this user anymore."
        block: "Block",
        editMessageTitle: "Edit your message",
        save: "Save",
    },
    loading: "Loading..."
}
